




































































































import { Component, Vue } from "vue-property-decorator";
import Userrole from "@/Pages/Admin/Modules/Admin/StoreUserInfo/Userrole";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";

@Component({})
export default class TheSideBar extends Vue {
  protected RequestOperator: any = [];
  constructor() {
        super();
        // this.RequestOperator.role = 'operator';
        this.RequestOperator.role = 'admin';
  }

  public toggleParent() {
     $( ".toggle-content" ).slideToggle( "medium");
        $( ".toggle-parent" ).toggleClass( "up");
  }

 public toggleParentHotel() {
    $(".toggle-content-hotel").slideToggle("medium");
    $(".toggle-parent-hotel").toggleClass("up");
  }
  get permission() {
    return common.permissionCheck;
  }
}
